import React from "react";
import { EDUCATION, CERTS } from "../data";

export default function Credentials() {
  return (
    <section id="credentials">
      <div className="section-head">
        <div className="label">§04 · credentials</div>
        <div className="h">Education and certifications</div>
        <div className="meta">
          {CERTS.length} certs · {EDUCATION.length} programmes
        </div>
      </div>

      <div className="cred-grid">
        {/* Education */}
        <div className="pane">
          <div className="pane-hd">
            <div className="dots"><i /><i /><i /></div>
            <div className="path">education.log</div>
            <div className="pane-hd-meta">{EDUCATION.length} entries</div>
          </div>
          <div className="cred-list">
            {EDUCATION.map((e) => (
              <div key={e.title} className="cred-row">
                <span className="cred-kind">{e.kind}</span>
                <span>
                  <div className="cred-title">{e.title}</div>
                  <div className="cred-org">{e.org}</div>
                </span>
                <span className="cred-when">{e.when || "—"}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Certifications */}
        <div className="pane">
          <div className="pane-hd">
            <div className="dots"><i /><i /><i /></div>
            <div className="path">certs.d/active</div>
            <div className="pane-hd-status">● all current</div>
          </div>
          <div className="cred-list">
            {CERTS.map((c) => (
              <div key={c.id} className="cert-row">
                <span className={"cert-id " + c.tier}>{c.id}</span>
                <span className="cert-title">{c.title}</span>
                <a
                  className="cert-link"
                  href={c.url}
                  target="_blank"
                  rel="noreferrer"
                >
                  verified ↗
                  <span className="sr-only"> (opens in new tab)</span>
                </a>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
